<div class="sec-head">
  <h2>{{ 'Alert delivery' | translate }}</h2>
  <p>{{ 'Choose where monitoring alerts are sent.' | translate }}</p>
</div>

<div class="as-card">
  <div class="as-row">
    <div class="tile"><app-account-icon name="mail" [size]="20"></app-account-icon></div>
    <div class="row-text">
      <b>{{ 'Email' | translate }}</b>
      <span class="email-target">{{ email }}</span>
    </div>
    <app-account-switch
      class="email-switch"
      [checked]="emailEnabled"
      [label]="'Email alerts' | translate"
      (toggled)="emailToggled.emit()"
    ></app-account-switch>
  </div>
</div>

@if (smsAlertsEnabled) {
<div class="as-card">
  <div class="as-row">
    <div class="tile" [class.tile-neutral]="!phoneVerified">
      <app-account-icon name="smartphone" [size]="20"></app-account-icon>
    </div>
    <div class="row-text">
      <div class="row-title">
        <b>{{ 'SMS' | translate }}</b>
        @if (phoneVerified) {
          <span class="as-badge badge-ok sms-badge">{{ phoneNumberDisplay }}</span>
        } @else if (hasPhoneNumber) {
          <span class="as-badge badge-warn sms-badge">{{ 'Unverified' | translate }}</span>
        } @else {
          <span class="as-badge sms-badge">{{ 'No number' | translate }}</span>
        }
      </div>
      <span class="sms-sub">
        @if (phoneVerified) {
          {{ 'Alerts will be texted to this number.' | translate }}
        } @else {
          {{ 'Text message alerts to your mobile phone.' | translate }}
        }
      </span>
    </div>
    <app-account-switch
      class="sms-switch"
      [checked]="smsEnabled"
      [disabled]="!phoneVerified"
      [label]="'SMS alerts' | translate"
      (toggled)="smsToggled.emit()"
    ></app-account-switch>
  </div>

  @if (phoneVerified) {
    <div class="sms-manage">
      <button type="button" class="as-btn-ghost change-number" (click)="manageNumber.emit()">
        {{ 'Change number' | translate }}
      </button>
    </div>
  } @else {
    <div class="notice sms-notice">
      <app-account-icon name="alert-circle"></app-account-icon>
      @if (hasPhoneNumber) {
        <span>{{ 'SMS will not be sent to this number until it is verified.' | translate }}</span>
        <button type="button" class="as-btn-outline add-number" (click)="manageNumber.emit()">
          {{ 'Set up SMS alerts' | translate }}
        </button>
      } @else {
        <span>{{ 'Add a mobile number to turn on SMS alerts.' | translate }}</span>
        <button type="button" class="as-btn-outline add-number" (click)="manageNumber.emit()">
          <app-account-icon name="plus" [size]="14" [strokeWidth]="2.5"></app-account-icon>
          {{ 'Add number' | translate }}
        </button>
      }
    </div>
  }
</div>
}
